import { PaymentMethod, ExpirationType } from '../autopay';

export class CreateAutopayRequest {
	postedInfo = null;
	constructor(
		public customerAccountKey: number,
		public autopayTriggerType: number,
		public autopayTriggerValue: number,
		public expirationType: ExpirationType,
		public maxPaymentAmount: number,
		public payInFull: boolean,
		public paymentMethod: PaymentMethod,
		public overriddenFeeAmount?: number,
		public numberOfPayments?: number,
		public endDate?: Date,
	){ }
}
